import React, { Component } from 'react';
import css from '../ProjectPage/ProjectPage.module.scss';
import Header from '../ProjectPage/Header';
import ProjectItem from '../ProjectItem.js';

import ImgY1 from './assets/Y1.jpg';
import ImgY2 from './assets/Y2.jpg';
import ImgY3 from './assets/Y3.jpg';

import ImgYNABTwitch from '../assets/YNABTwitch.png';
import ImgGnostMono from '../assets/GnostMono.png';

export default class Twitch extends Component {

  render () {
      return (
        <div className={css.projectPage}>
          <Header
            title='YNAB Mobile Redesign'
            year='2020'
            exploration='Spec Redesign'
          />
          <div className={css.content}>
            <img src={ImgY1} alt='YNAB Mobile Screens' />
            <div className={css.text}>
              <p>You Need a Budget, YNAB, is one of my favourite products. It's given me tremendous insight into my spending and helped me hit major savings goals for my wedding and buying a house. </p>
              <p>YNAB is all about staying within budget and it nails that experience. Every category of spending gets a preallocation of funds every month and then as you spend from that category the balance draws down to zero. Simple! </p>
              <p>In the current mobile experience, there’s a column for this month’s funds budgeted into each category and for the available amount. When I’m out and about I find that I really only need to know how much I can spend from a category so in my design I’ve simplified to just the available amount and then added a line of contextual information in a human readable format, just so I don’t have to do mental math on the go. The addition of icons for each category also helps distinguish the more spacious table rows at a glance.</p>
            </div>
            <img src={ImgY2} alt='Budget Screen Before and After' />
            <div className={css.text}>
              <p>As someone that came to YNAB after trying several other budgeting and financial products (Simple, Mint, Level, Motif, Robinhood, Quicken, Quickbooks), I love the idea of goals as something to rally behind and get excited about. In a way, budgets look backwards at what you've spent, while goals look forward to things you want to spend on. </p>
              <p>The current YNAB mobile experience hides goals behind a tap from the categories view. To bring goals to the forefront, I've added a new top level tab where you can see all your goals at a glance. Each goal is linked to a budget item the same way they are now, so it's more a function of surfacing a feature that already exists and that I love instead of adding something new. </p>
              <p>In addition to bringing goals front and center, I’ve also revamped the Reports view to make it more dynamic, contextual, and action oriented. I got into using YNAB because I wanted to better plan for the future so in this redesign I’ve taken forecasting to the next level. On the Net Worth graph I added a forecast line so I can quickly see if I’m on the right track to hitting my long term goals. I’ve also added notification cards which draw attention to important timely information like falling behind on savings goals or upcoming bills. </p>
            </div>
            <img src={ImgY3} alt='YNAB Mobile Screens' />
          </div>
          <div className={css.moreWork}>
            <header>More Projects</header>
              <ul className={css.moreWorkList}>
                <ProjectItem
                  title='YNAB x Twitch CoreUI'
                  description='A spec redesign of the YNAB website'
                  exploration='Spec Redesign'
                  img={ImgYNABTwitch}
                  link='YNABTwitch'
                />
                <ProjectItem
                  title='Gnost Mono'
                  description='Mono spaced type design'
                  exploration='Type Design'
                  img={ImgGnostMono}
                  link='GnostMono'
                />
              </ul>
          </div>
        </div>
      )
   }
}
